import { useQuery } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';

/**
 * GET /api/eraf/integration-hub/storage/backend — 현재 파일 backend 정보 (INTEGRATION_READ)
 * queryKey: ['integration-hub', 'storage', 'backend']
 */
export function useFileBackendInfo() {
  return useQuery({
    queryKey: ['integration-hub', 'storage', 'backend'],
    queryFn: () => integrationHubApi.getStorageBackend(),
    staleTime: 60_000,
  });
}
